import qs from 'qs';
import request from '@/config/request';

/*
  获取礼品券列表
  ticketContent
*/
export function getAssistantTicketList({ page, pageSize, ...rest }) {
  return request({
    url: `/ticket/getAssistantTicketList?page=${page}&pageSize=${pageSize}`,
    method: 'post',
    data: qs.stringify(rest),
  });
}

/*
  获取兑换券列表
  ticketName，userName
*/
export function getMyTicketList({ page, pageSize, ...rest }) {
  return request({
    url: `/ticket/getMyTicketList?page=${page}&pageSize=${pageSize}`,
    method: 'post',
    data: qs.stringify(rest),
  });
}

/*
  获取会员列表
  userPhone
*/
export function getShopUserList(userPhone) {
  return request({
    url: '/ticket/getShopUserList',
    method: 'post',
    data: qs.stringify({ userPhone }),
  });
}

/*
  添加礼品券
  ticketName, ticketContent，ticketBeginTime，ticketEndTime，userIds
*/
export function addAssistantTicket(rest) {
  return request({
    url: '/ticket/addAssistantTicket',
    method: 'post',
    data: qs.stringify(rest),
  });
}

/*
  获取礼品券详情
  id
*/
export function getAssistantTicketAndUser(id) {
  return request({
    url: '/ticket/getAssistantTicketAndUser',
    method: 'post',
    data: qs.stringify({ id }),
  });
}

/*
  查看礼品券
  id
*/
export function getAssistantTicket(id) {
  return request({
    url: '/ticket/getAssistantTicket',
    method: 'post',
    data: qs.stringify({ id }),
  });
}

/*
  查看兑换券
  id
*/
export function getMyTicket(id) {
  return request({
    url: '/ticket/getMyTicket',
    method: 'post',
    data: qs.stringify({ id }),
  });
}

/*
  编辑礼品券
  id，ticketName, ticketContent，ticketBeginTime，ticketEndTime，userIds
*/
export function updateAssistantTicket(rest) {
  return request({
    url: '/ticket/updateAssistantTicket',
    method: 'post',
    data: qs.stringify(rest),
  });
}

/*
  礼品券上架
  id
*/
export function updateAssistantTicketUp(id) {
  return request({
    url: '/ticket/updateAssistantTicketUp',
    method: 'post',
    data: qs.stringify({
      id,
    }),
  });
}

/*
  礼品券下架
  id
*/
export function updateAssistantTicketDown(id) {
  return request({
    url: '/ticket/updateAssistantTicketDown',
    method: 'post',
    data: qs.stringify({
      id,
    }),
  });
}

/*
  查询导出
  userName, userPhone，integralMin，integralMax，beginTime，endTime
*/
export function excelPort(rest) {
  return request({
    url: '/ticket/export',
    method: 'get',
    params: rest,
    responseType: 'blob',
  });
}
